"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.regexp.match");

/* eslint-disable no-useless-escape */
var rules = {
  regName: {
    number: /^[0-9]*$/,
    phone: /^(1)\d{10}$/,
    idNo: /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/,
    email: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
    chinese: /^[\u4e00-\u9fa5]*$/
  },
  funcName: {
    require: function require(checkItem) {
      return !!checkItem;
    },
    maxValue: function maxValue(checkItem, value) {
      return checkItem <= value;
    },
    minValue: function minValue(checkItem, value) {
      return checkItem >= value;
    },
    maxLength: function maxLength() {
      var checkItem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var value = arguments.length > 1 ? arguments[1] : undefined;
      return checkItem.length <= value;
    },
    minLength: function minLength() {
      var checkItem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var value = arguments.length > 1 ? arguments[1] : undefined;
      return checkItem.length >= value;
    },
    minChinese: function minChinese() {
      var checkItem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var value = arguments.length > 1 ? arguments[1] : undefined;
      return checkItem.match(/[\u4e00-\u9fa5]/g).length >= value;
    },
    maxChinese: function maxChinese() {
      var checkItem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var value = arguments.length > 1 ? arguments[1] : undefined;
      return checkItem.match(/[\u4e00-\u9fa5]/g).length <= value;
    },
    idNo: function idNo() {
      var checkItem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var city = {
        11: "北京",
        12: "天津",
        13: "河北",
        14: "山西",
        15: "内蒙古",
        21: "辽宁",
        22: "吉林",
        23: "黑龙江 ",
        31: "上海",
        32: "江苏",
        33: "浙江",
        34: "安徽",
        35: "福建",
        36: "江西",
        37: "山东",
        41: "河南",
        42: "湖北 ",
        43: "湖南",
        44: "广东",
        45: "广西",
        46: "海南",
        50: "重庆",
        51: "四川",
        52: "贵州",
        53: "云南",
        54: "西藏 ",
        61: "陕西",
        62: "甘肃",
        63: "青海",
        64: "宁夏",
        65: "新疆",
        71: "台湾",
        81: "香港",
        82: "澳门",
        91: "国外 "
      };
      var tip = "";
      var pass = true;

      if (!checkItem || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(checkItem)) {
        tip = "身份证号格式错误";
        pass = false;
      } else if (!city[checkItem.substr(0, 2)]) {
        tip = "地址编码错误";
        pass = false;
      } //18位身份证需要验证最后一位校验位
      else if (checkItem.length === 18) {
          var code = checkItem.split(''); //∑(ai×Wi)(mod 11)
          //加权因子

          var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]; //校验位

          var parity = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
          var sum = 0;

          for (var i = 0; i < 17; i += 1) {
            sum += code[i] * factor[i];
          }

          if (parity[sum % 11] !== code[17]) {
            tip = "校验位错误";
            pass = false;
          }
        }

      if (!pass) {
        console.log(tip);
      }

      return pass;
    }
  }
};
var _default = rules;
exports.default = _default;